var _path, _path2, _circle, _rect, _g, _circle2, _rect2, _g2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanvas3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 194,
    viewBox: "0 0 1302 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 35C97 15.67 112.67 0 132 0H1230V194H132C112.67 194 97 178.33 97 159V35Z",
    fill: "#2E3092"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97 0H1230V194L97 0Z",
    fill: "#23257D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 89,
    r: 61,
    fill: "#011B25"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_869_719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 28,
    width: 122,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 28,
    width: 122,
    height: 61,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_869_719)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 89,
    r: 61,
    fill: "#032A39"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 91,
    stroke: "#011B25",
    strokeWidth: 12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_869_719",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 97
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 97,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_869_719)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97,
    cy: 97,
    r: 91,
    stroke: "#032A39",
    strokeWidth: 12
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1230 30H1287C1295.28 30 1302 36.7157 1302 45V149C1302 157.284 1295.28 164 1287 164H1230V30Z",
    fill: "#032A39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1230 98H1302V149C1302 157.284 1295.28 164 1287 164H1230V98Z",
    fill: "#011B25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.28 106.52C97.4907 106.52 91.0773 106.173 84.04 105.48V98.46C91.7013 98.98 97.4213 99.24 101.2 99.24C101.997 99.24 102.621 99.0147 103.072 98.564C103.557 98.0787 103.8 97.4373 103.8 96.64V94.56C103.8 92.48 102.76 91.44 100.68 91.44H89.76V84.16H99.64C101.72 84.16 102.76 83.12 102.76 81.04V80C102.76 77.92 101.72 76.88 99.64 76.88H84.56V69.6H102.24C105.637 69.6 108.133 70.38 109.728 71.94C111.323 73.4653 112.12 75.8053 112.12 78.96C112.12 81.04 111.635 82.7387 110.664 84.056C109.728 85.3387 108.48 86.24 106.92 86.76C109.728 87.5227 111.635 89.3947 112.64 92.376C112.987 93.4507 113.16 94.6987 113.16 96.12V96.64C113.16 100.037 112.363 102.533 110.768 104.128C109.173 105.723 106.677 106.52 103.28 106.52Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvas3);
export default __webpack_public_path__ + "static/media/canvas3.ba5e8205843a6edf0d63a84caedb5bbe.svg";
export { ForwardRef as ReactComponent };